module.exports = __webpack_public_path__ + "static/media/ABNB_Report_IPOIntelligence_e.63f000b7.png";